export default "__VITE_ASSET__CPIgzM3d__"